<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LgbvOD/tc-custom/9781528997362.jpg?1674914705070" alt="This image is the cover for the book German Girls"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">German Girls
      </h1>
      <p class="bookDescription body article font2">
        <p>Paul is totally smitten by the lovely Heidi during a holiday encounter in Swanage in the summer of 1978. Will their holiday romance become something much more serious when he sets out to see if his love for her blossoms in her home city of Frankfurt?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steve Barber
      </h2>
      
      <p class="authorDescription body article">Steve Barber is a confident introvert who has greatly enjoyed writing since his early 20s. He has had a long, diverse and satisfying career in the health and beauty industry, and in addition to German Girls, he has written many children’s stories and poems for his beloved Sarah and Dan. Steve lives with his wonderful wife, Ine, and two cats on the south coast of England. His favourite authors are Anne Tyler, Chris Stewart and Alexander McCall Smith. Steve enjoys walking, wildlife watching and being by the sea.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8907534a